import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, Box, Divider, Button, ButtonGroup } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import DraftsIcon from '@material-ui/icons/Drafts';
import RoomIcon from '@material-ui/icons/Room';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import ContrastButton from './ContrastButton'
import ContrastButtonGroup from './ContrastButtonGroup'

const useStyles = makeStyles((theme) => ({
    root: {
        background: theme.palette.primary.main,
        color: theme.palette.getContrastText(theme.palette.primary.main),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    divider: {
        background: 'rgba(255, 255, 255, .2)'
    },
    links: {
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(-0.5)
        }
    },
    socialIcons: {
        '& svg': {
          fontSize: theme.spacing(3.7),
          color: theme.palette.getContrastText(theme.palette.primary.main)
        },
        [theme.breakpoints.up('md')]: {
            marginRight: theme.spacing(-0.5)
        }
    }
}))

export default function Footer({ links }) {
    const classes = useStyles();
    const history = useHistory();

    const linkItems = links.map((link, i) =>
        <ContrastButton key={i} size="small" onClick={e => history.push(link.path)}>
            {link.name}
        </ContrastButton>
    )

    return (
        <footer className={classes.root}>
            <Container maxWidth="lg">
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} component={Box} textAlign={{ xs: 'center', md: 'left' }}>
                        <b>About RQuaL Solutions</b><br />
                        <Box mt={{xs: 1, md: 2}} pr={{md: 5}} lineHeight={1.75}>
                            RQuaL is a Leading Quality Compliance &amp; Regulatory Consulting Firm founded by Avtar Singh.
                            We provide the Pharmaceutical industry with innovative and customized Solutions ... 
                            <ContrastButton size="small" onClick={e => history.push("/about-us")}>Read More</ContrastButton>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} component={Box} textAlign={{ xs: 'center', md: 'left' }}>
                        <Box mb={1} fontWeight="bold">
                            Site Links
                        </Box>
                        <ContrastButtonGroup variant="text" size="small" className={classes.links}>
                            {linkItems}
                        </ContrastButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={2} component={Box} textAlign={{ xs: 'center', md: 'right' }}>
                        <b>Connect with us</b><br/><br/>
                        <ButtonGroup size="small" className={classes.socialIcons}>
                            <Button 
                                variant="text" 
                                aria-label="linkedin" 
                                onClick={e => window.open('https://www.linkedin.com/company/rqual-solutions')}
                            >
                                <LinkedInIcon/>
                            </Button>
                            <Button 
                                variant="text" 
                                aria-label="twitter" 
                                onClick={e => window.open('http://twitter.com/@RQuaLSolutions')}
                            >
                                <TwitterIcon />
                            </Button>
                            <Button 
                                variant="text" 
                                aria-label="whatsapp" 
                                onClick={e => window.open('https://wa.me/+919317553000')}
                            >
                                <WhatsAppIcon/>
                            </Button>
                            <Button 
                                variant="text" 
                                aria-label="email" 
                                onClick={e => window.open('mailto:info@rqual.com')}
                                className={classes.socialIcons}
                            >
                                <DraftsIcon/>
                            </Button>
                        </ButtonGroup>
                        {/* <Box mt={{xs: 1, md: 2}} onClick={e => window.open('https://goo.gl/maps/Q59zS2SsqtACK54r9')}> */}
                        <Box mt={{xs: 1, md: 2}}>
                            <RoomIcon style={{marginBottom: -2, fontSize: 16}} /> Mohali, Punjab<br/>IN &ndash; 140 301
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider variant="middle" light={false} className={classes.divider} />
                        <Box textAlign='center' fontSize="caption.fontSize" mt={2} mb={-1}>
                            Copyright &copy; 2020 RQuaL Solutions. All rights reserved.
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </footer>
    )
}